// extracted by mini-css-extract-plugin
module.exports = {"AskUser":"AskUser_AskUser__21H_K","mainSide":"AskUser_mainSide__1tXiP"};